<template>
    <button
        @click="remove"        
        :class="[isActive ? 'active' : 'pending', isStatic ? 'static': '']"
        class="filter-pill"
        ><i v-if="!isStatic" class="fa fa-times-circle" aria-hidden="true"></i> {{name}}</button>
</template>
<script>
import { FilterType, StaticFilters } from '../@types/Filters'
import { htmlDecode } from '../@types/Helpers'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return  {
            active: false,
            cssClass: 'pending'
        }        
    },
    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        handle:  {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        }
    },
    computed: {
        isActive: {
            set(newVal) { this.active = newVal; },
            get() {
                let active = false;

                this.getFilters().forEach(term => {
                    if (term.handle === this.handle) {
                        active = true;
                    }   
                })

                return active;
            }
        },
        isStatic() {
            return [StaticFilters.Catalog.handle, StaticFilters.SampleOptions.handle].includes(this.handle)
        }
    },
    methods: {
        ...mapGetters(['getFilters']),
        ...mapActions(['removeFilter']),
        remove() {
            if (!this.isStatic) {
                const {type, handle, value} = this
                this.removeFilter({
                    type,
                    handle,
                    value
                })
            }            
        }
    }
}
</script>
